export default __webpack_public_path__ + "static/media/timeline.cb2920bc.svg";